import logo from './logo.svg';
import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { darkTheme } from './Theme/darkTheme';
import Navbar from './component/Navbar/Navbar';
import Home from './component/Home/Home';
import RestaurantDetails from './component/Restaurant/RestaurantDetails';
import Cart from './component/Cart/Cart';
import ProfileNavigation from './component/Profile/ProfileNavigation';
import CustomerRoute from './Routers/CustomerRoute';
import Routers from './Routers/Routers';
import Sample from './Theme/Sample';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from './component/State/store';
import { getUser } from './component/State/Authentication/Action';
import { findCart } from './component/State/Cart/Action';
import { getRestaurantById, getRestaurantByUserId } from './component/State/Restaurant/Action';

function App() {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt")
  const { auth } = useSelector(store => store)

  useEffect(() => {
    dispatch(getUser(auth.jwt || jwt))
    dispatch(findCart(jwt))
  }, [auth.jwt])
  useEffect(() => {
    dispatch(getRestaurantByUserId(auth.jwt || jwt))
  
  }, [auth.user])
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {/* <Navbar/> */}
      {/* <Home/>
       <RestaurantDetails/>
       <Cart/> */}
      {/* <ProfileNavigation/> */}
      {/* <CustomerRoute/> */}
      <Routers />
      {/* <Sample/> */}
    </ThemeProvider>
  );
}

export default App;
